import type { CSSProperties } from 'react';

import type { ConversationDetailView } from '../../api/chat.types';
import { Button, ProgressBar } from '../../ds';
import { Avatar } from '../social/Avatar';
import { useSocial } from '../social/SocialContext';
import { SocialIcon } from '../social/SocialIcon';

const sectionLabel: CSSProperties = { fontSize: 11, fontWeight: 700, letterSpacing: 0.6, textTransform: 'uppercase', color: 'var(--text-secondary)' };

/** Thông tin nhóm: cột phải khi màn rộng (≥ 1280px), trong modal khi màn hẹp hơn. */
export function GroupInfoPanel({ conversation: c, docked }: { conversation: ConversationDetailView; docked: boolean }) {
  const { me, toast } = useSocial();
  return (
    <div
      style={{
        ...(docked ? { width: 300, flexShrink: 0, borderLeft: '1px solid var(--border-default)' } : { maxHeight: '80vh' }),
        overflowY: 'auto',
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        background: 'var(--surface-page)',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, textAlign: 'center' }}>
        <Avatar name={c.name} size={72} mark={c.mark} tone={0} />
        <div>
          <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--ink)' }}>{c.name}</div>
          <div style={{ fontSize: 12.5, color: 'var(--text-secondary)', marginTop: 2 }}>
            {`${c.memberCount} thành viên · ${c.isPublic ? 'Công khai' : 'Riêng tư'}${c.focus ? ` · ${c.focus}` : ''}`}
          </div>
        </div>
      </div>

      {c.weeklyGoal != null && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <span style={sectionLabel}>Mục tiêu tuần</span>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, fontWeight: 600, color: 'var(--ink)' }}>
            <span>{`${c.weeklyGoal} thẻ SRS`}</span>
            <span style={{ color: 'var(--text-secondary)' }}>{`${c.goalProgress ?? 0}/${c.weeklyGoal}`}</span>
          </div>
          <ProgressBar value={c.goalProgress ?? 0} max={c.weeklyGoal} />
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <span style={sectionLabel}>Thành viên</span>
        {c.members.map((m) => (
          <div key={m.id} style={{ display: 'flex', alignItems: 'center', gap: 10, minHeight: 44 }}>
            <Avatar name={m.name} size={32} online={m.online} />
            <span style={{ flex: 1, minWidth: 0 }}>
              <span style={{ display: 'block', fontSize: 13.5, fontWeight: 600, color: 'var(--ink)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {m.id === me?.id ? `${m.name} (bạn)` : m.name}
              </span>
              <span style={{ display: 'block', fontSize: 12, color: 'var(--text-secondary)' }}>{m.level}</span>
            </span>
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <Button variant="secondary" style={{ justifyContent: 'center' }} icon={<SocialIcon name="users" size={17} />} onClick={() => toast('Mời thêm bạn sắp có')}>
          Mời thêm bạn
        </Button>
        <Button variant="ghost" style={{ justifyContent: 'center', color: 'var(--error)' }} onClick={() => toast('Rời nhóm sắp có')}>
          Rời nhóm
        </Button>
      </div>
    </div>
  );
}
